import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shuffle from 'lodash/shuffle';
import get from 'lodash/get';

import withTour from '../../../../components/hocs/withTour';
import BlankCard from '../../../../components/ui/cards/BlankCard';
import PersonalityResultsPieChart from '../../../../components/ui/charts/zoom/PersonalityResultsPieChart';
import selectors from '../../../../store/shared/selectors';

import PersonalitySummary from './PersonalitySummary';

import Search360Link from '../../Search/routes/Career/components/Search360Link';
import TopJobs from './components/TopJobs';
import sendFullStoryEvent from '../../../../utils/analyticsHelpers/sendFullStoryEvent';
import fullstory from '../../../../utils/constants/fullstory';

class ResultsWrapper extends Component {
  static propTypes = {
    clear: PropTypes.func.isRequired,
    result: PropTypes.any.isRequired,
    personalityResultData: PropTypes.any.isRequired,
    isLessThanMedium: PropTypes.bool,
    gender: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeIndex: 0,
    }

    this.onChangeActiveIndex = nextIndex => this.setState({ activeIndex: nextIndex })
  }

  render() {
    const {
      clear,
      result: { personalityTraits },
      isLessThanMedium,
      personalityResultData,
    } = this.props

    const personalityTypeAcronym = get(personalityResultData, 'personalityTypeAcronym')
    const characterArchetype = get(personalityResultData, 'characterArchetype')
    const description = get(personalityResultData, 'description')
    const fullPersonalityType = get(personalityResultData, 'fullPersonalityType')
    const imageUrl = get(personalityResultData, 'imageUrl')
    const reportLink = get(personalityResultData, 'reportLink')
    const tagLine = get(personalityResultData, 'tagLine')
    const topMajors = shuffle(get(personalityResultData, 'majorResults.topMajors.majors', []))
    const topMajorsDescription = get(personalityResultData, 'majorResults.topMajors.description')
    const topJobs = get(personalityResultData, 'jobResults.topJobs.jobs', [])
    const commonJobs = shuffle(get(personalityResultData, 'jobResults.commonJobs.jobs', []))


    return (
      <div className="col-xl-12 p-0">
        <div className="row d-flex justify-content-end align-content-center">
          <a
            onClick={() => {
              sendFullStoryEvent(fullstory.eventNames.restartPersonalityAssessment)
              clear()
            }}
            className="btn"
          >
            <i className="fal fa-sync-alt" /> &nbsp;Restart Assessment
          </a>
        </div>
        <div id="resultsContainer">
          <BlankCard style={{ marginBottom: 60 }} delay={0.5}>
            <h2 className="text-center mt-2">
              {personalityTypeAcronym} : {characterArchetype}
            </h2>
            <h3 className="text-center">{tagLine}</h3>

            <div className="row" style={{ minHeight: 495 }}>
              <div className="col-md-6">
                <PersonalityResultsPieChart
                  image={imageUrl}
                  chartData={personalityTraits}
                  height={isLessThanMedium ? 200 : 350}
                />
                <div className="text-center">
                  <p style={{ marginBottom: 20 }}>
                    <a href="https://giphy.com/">via GIPHY</a>
                  </p>
                </div>
              </div>

              <div className="col-md-6 mt-3" id="resultSummary">
                <div style={{ marginTop: 0, padding: 20 }}>
                  <PersonalitySummary
                    description={description}
                    personalityTypeAcronym={personalityTypeAcronym}
                    fullPersonalityType={fullPersonalityType}
                  />
                </div>
              </div>

              <div className="text-center" style={{ margin: '0 auto' }}>
                <a
                  href={reportLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-primary"
                  onClick={() => {
                    const eventProperties = {
                      personality_type_str: personalityTypeAcronym,
                      report_link_str: reportLink,
                    }
                    sendFullStoryEvent(
                      fullstory.eventNames.customPersonalityAssessmentReport,
                      eventProperties,
                    )
                  }}
                >
                  Custom Personality Report
                </a>
              </div>
            </div>
          </BlankCard>

          <BlankCard style={{ marginBottom: 60 }} delay={0.6}>
            <div className="row">
              <div className="col">
                <h2 className="mt-2 mb-4">Best Majors for {personalityTypeAcronym}s</h2>
                <p>{topMajorsDescription}</p>
              </div>
            </div>

            <div className="row" style={{ padding: '0 20px 30px' }}>
              {topMajors.slice(0, 12).map(major => {

                return (
                  <div key={major.title} className="col-md-4 mt-2">
                    <Search360Link rec={major.title} recType="education" />
                  </div>
                )
              })}
            </div>
          </BlankCard>

          <BlankCard style={{ marginBottom: 60 }} delay={0.6}>
            <div className="row" style={{ marginBottom: 30 }}>
              <div className="col">
                <h2 className="mt-2 mb-4">Best Jobs for {personalityTypeAcronym}s</h2>
              </div>
            </div>

            <TopJobs topJobs={topJobs} />
            <div className="row">
              <div className="col-12">
                <h4>Other Common Jobs for {personalityTypeAcronym}s</h4>
              </div>
            </div>

            <div className="row" style={{ padding: '0 20px 30px' }}>
              {commonJobs.slice(0, 12).map(job => {
                return (
                  <div key={job.title} className="col-md-4 mt-2">
                    <Search360Link rec={job.title} recType="career" />
                  </div>
                )
              })}
            </div>
          </BlankCard>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLessThanMedium: selectors.isLessThanMedium(state),
})

const tourSteps2 = [
  {
    selector: '#resultsContainer',
    content: 'Review the results of your personality assessment here.',
  },
  {
    selector: '#resultSummary',
    content: 'Your personality summary and suggestion results are here on the right.',
  },
  {
    selector: '#personalityTabs',
    content: 'Switch between your summary, education suggestions, and matching careers here. ',
  },
]

export default connect(mapStateToProps)(withTour('personalityResult', tourSteps2)(ResultsWrapper))



// WEBPACK FOOTER //
// ./src/routes/authenticated/PersonalityAssessment/components/ResultsWrapper.js